<template>
  <article>
    <section class="section font-roboto">
      <div>
        <h1
          class="mb-8 text-[20px] font-medium leading-[26px] xl:text-[32px] xl:leading-[38px]"
        >
          МОБИЛЬНОЕ ПРИЛОЖЕНИЕ И САЙТ
          <a target="_blank" href="https://history.ru">ИСТОРИЯ.РФ</a>
        </h1>
        <div
          class="mb-2 text-[16px] leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          <div class="mb-3">
            <a target="_blank" href="https://history.ru">История.РФ</a> –
            уникальный ресурс, содержащий обширную коллекцию материалов для
            изучения истории России, Российской Федерации и мира. Информационные
            материалы портала представлены в разнообразных форматах - видео,
            аудио, статьи и новостной дайджест, энциклопедические и исторические
            словари, оригиналы исторических и архивных документов, карты и
            презентации. Все информационные материалы подготовлены экспертами и
            дипломированными специалистами в области истории.
          </div>
          <div class="mb-3">
            <a target="_blank" href="https://history.ru">История.РФ</a> –
            идеальное место для изучения истории России как для широкой
            аудитории, интересующейся историей Отечества, так и в качестве
            незаменимого образовательного ресурса для подрастающего поколения.
            Для учащихся портал
            <a target="_blank" href="https://history.ru">История.РФ</a> –
            кладезь информации для создания рефератов и эссе, подготовки к любым
            тестам и экзаменам. Благодаря информации портала
            <a target="_blank" href="https://history.ru">История.РФ</a>
            школьники получают возможность отвечать на самые сложные и каверзные
            вопросы на олимпиадах по истории, успешно участвовать в конкурсах и
            тестах.
          </div>
          <div class="mb-3">
            С 2024 года
            <a target="_blank" href="https://history.ru">История.РФ</a>
            реализует проект «Учителю и ученику», который представляет все
            материалы сайта в соответствии со структурой новых единых учебников
            по истории. Проект предлагает дополнительные материалы к теме
            каждого параграфа учебника. Все материалы подготовлены в
            соответствии с ФГОС и полностью охватывают учебную программу.
          </div>
          <div class="mb-3">
            В период, когда Россия переходит на преподавание истории в
            соответствии с единой линейкой учебников, проект
            <a target="_blank" href="https://history.ru">История.РФ</a>
            оказывает методическую и содержательную поддержку учителям и
            методистам в их работе, а для учеников раскрывает историю России во
            всем богатстве, сложности и многообразии.
          </div>
          <div>
            По всем вопросам, связанным с работой мобильного приложения
            <a target="_blank" href="https://history.ru">История.РФ</a>,
            обращайтесь на электронную почту:
            <a href="mailto:askhistexpert@histrf.ru">askhistexpert@histrf.ru</a>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script setup></script>

<style lang="scss" scoped>
a {
  @apply text-ruby-red-100 hover:text-ruby-red-56;
}
</style>
